import React from "react";

function Footer() {
  return (
    <div>
      <footer class="info">
        <p>Click to edit a todo</p>
        <p>
          Stolen by <a href="https://github.com/furkanlebit7">Furkan Lebit</a>{" "}
          from <a href="https://d12n.me/">Dmitry Sharabin</a>
        </p>
        <p>
          Part of <a href="http://todomvc.com">TodoMVC</a>
        </p>
      </footer>
    </div>
  );
}

export default Footer;
